import React from "react"
import { Col, Container, Row, Form } from "react-bootstrap"
import AccordionCard from "./AccordionCard"
import TestCardProps from "./TestCardProps"
import CardRow from "./CardRow"
import { EventData } from "../../../../api/OrderResults/OrderResultModel/ServiceDetails"
import FormatDate from "../../../../formatters/FormatDate"
import { AltReasonDescriptionByCode, IsAltOtherExcuseReason } from "../../../../api/Randoms/RandomsModel/ExcuseReason"

type SchedulingResult = {
  schedulingStatus: string,
  schedulingDate: string | null,
}
function getSchedulingData(data: EventData): SchedulingResult {
  let result: SchedulingResult = { schedulingStatus: "", schedulingDate: "" }
  if (data.DateScheduled) {
    result.schedulingStatus = data.ScheduleStatusDescription
    result.schedulingDate = FormatDate(data.DateScheduled)
  } else if (data.DateNotified) {
    result.schedulingStatus = "Notified"
    result.schedulingDate = FormatDate(data.DateNotified)
  } else if (data.DateOrdered) {
    result.schedulingStatus = "Created"
    result.schedulingDate = FormatDate(data.DateOrdered)
  }
  return result
}

export default function CollectionCard(props: TestCardProps) {
  const data = props.data.EventData
  const schedulingResult = getSchedulingData(data)
  const schedulingNotes = data.SchedulingNotes || ""
  const excuseReasonCode = data.ExcuseReasonCode || ""
  const excuseReasonText = AltReasonDescriptionByCode(excuseReasonCode)
  const excuseComment = data.ExcuseComment || ""
  const isAltOtherExcuseReason = IsAltOtherExcuseReason(excuseReasonCode)
  const showSchedulingNotes = schedulingNotes.trim().length > 0
  const showExcuseReason = excuseReasonCode.startsWith("ALT_")
  const showExcuseComment = isAltOtherExcuseReason && excuseComment.trim().length > 0

  const title = <Row>
    <Col xs={5} sm={3} className="test-property">SCHEDULING</Col>
    <Col xs={3} sm={5} className="status-text">{schedulingResult.schedulingStatus}</Col>
    <Col xs={4} sm={4} className="status-text">{schedulingResult.schedulingDate}</Col>
  </Row>
  return (
    <AccordionCard eventKey="scheduling" title={title}>
      <Container fluid>
        <Row>
          <Col lg={6} className="pl-0">
            <CardRow titleBreakpoints={{ md: 8 }} valueBreakpoints={{ md: 4 }} title="ORDERED BY" />
            <CardRow titleBreakpoints={{ md: 8 }} valueBreakpoints={{ md: 4 }} title="CREATED DATE" value={data.DateOrdered} date />
            <CardRow titleBreakpoints={{ md: 8 }} valueBreakpoints={{ md: 4 }} title="CREATED TIME" value={data.DateOrdered} time />
            <CardRow titleBreakpoints={{ md: 8 }} valueBreakpoints={{ md: 4 }} title="NOTIFIED DATE" value={data.DateNotified} date />
            <CardRow titleBreakpoints={{ md: 8 }} valueBreakpoints={{ md: 4 }} title="NOTIFIED TIME" value={data.DateNotified} time />
            <CardRow titleBreakpoints={{ md: 8 }} valueBreakpoints={{ md: 4 }} title="SCHEDULED DATE" value={data.DateScheduled} date />
            <CardRow titleBreakpoints={{ md: 8 }} valueBreakpoints={{ md: 4 }} title="SCHEDULED TIME" value={data.DateScheduled} time />
          </Col>
          {(showSchedulingNotes || showExcuseReason || showExcuseComment) && <Col lg={6} className="px-0">
            <Form.Row>
              {showSchedulingNotes &&
                <Form.Control
                  as="textarea"
                  rows={3}
                  disabled={true}
                  className="bg-white h-100"
                  value={schedulingNotes} />}
              {showExcuseReason && <Form.Label>{excuseReasonText}</Form.Label>}
              {showExcuseComment &&
                <Form.Control
                  as="textarea"
                  rows={3}
                  disabled={true}
                  className="bg-white h-100"
                  value={excuseComment} />}
            </Form.Row>
          </Col>}
        </Row>
      </Container>
    </AccordionCard>
  )
}
